import { ServiceType } from '@uipath/portal-shell-util';

export interface INotification {
    id: string;
    message: string;
    notificationId: string;
    priority: NotificationPriority;
    redirectionUrl: string;
    publisherName: ServiceType;
    publishedOn: number;
    topicId: string;
    topicName: string;
    tenantId: string;
    userEmail: string;
    userId: string;
    isRead: boolean;
    isHidden: boolean;
}

export interface INotificationUpdateRead {
    notificationId: string;
    read: boolean;
}
export interface INotificationReadRequest {
    notifications: INotificationUpdateRead[];
    forceAllRead: boolean;
}

export interface INotificationDeleteRequest {
    notifcationIds: string[];
    deleteAll?: boolean;
}

export interface IUserSubscription {
    topicId: string;
    isSubscribed: boolean;
}

export interface IUpdateUserSubscription {
    userSubscriptions: IUserSubscription[];
}

export interface IUnsubscribeTenant {
    tenantId: string;
}

export enum NotificationPriority {
    Low = 'Low',
    Medium = 'Medium',
    High = 'High',
    Critical = 'Critical',
}
